import Layout from '../../layout/detailAi.vue';
const articleRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'drcnetArticle',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/ai',
			component: () =>
				import(
					'@/pages/detailspage/views/articleDetailAiIframe/index.vue'
				),
			name: 'detailAi',
		},
	],
};

export default articleRouter;
